import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import httpClient from "../../utils/httpClient";

export interface ResponseError {
  message: string;
}

export interface MaintenanceWindowState {
  isLoading: boolean;
  data: any;
  error: string | null;
}

const initialState: MaintenanceWindowState = {
  isLoading: false,
  data: null,
  error: null,
};

export const getMaintenanceWindowData = createAsyncThunk<
  any,
  void,
  { rejectValue: ResponseError }
>("MaintenanceWindowSlice/maintenanceWindow", async (_, thunkApi) => {
  try {
    const response = await httpClient.get("/systemuser/maintenance/list");
    if (response.status != 200 || response.data.Status !== "success") {
      if (response.data.Status == "error") {
        return thunkApi.rejectWithValue({
          message: response.data.Message,
        });
      } else {
        return thunkApi.rejectWithValue({
          message: "Failed to get maintenance details.",
        });
      }
    }
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue({
      message: "Failed to get maintenance details.",
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.log("🚀 ~ error:", error);
    return thunkApi.rejectWithValue({
      message: "Failed to get maintenance details.",
    });
  }
});

const MaintenanceWindowSlice = createSlice({
  name: "MaintenanceWindowSlice",
  initialState,
  reducers: {
    resetMaintenanceWindow: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMaintenanceWindowData.pending, (state) => {
        state.isLoading = true;
        state.data = null;
        state.error = null;
      })
      .addCase(
        getMaintenanceWindowData.fulfilled,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (state, action: PayloadAction<any>) => {
          if (action.payload.Status == "success") {
            state.isLoading = false;
            state.data = action.payload.Data ?? action.payload;
            state.error = null;
          } else {
            state.isLoading = false;
            state.data = null;
            state.error = action.payload.message;
          }
        },
      )
      .addCase(
        getMaintenanceWindowData.rejected,
        (state, action: PayloadAction<any>) => {
          state.isLoading = false;
          state.data = null;
          state.error =
            action?.payload?.message || "Failed to get maintenance details.";
        },
      );
  },
});

export const { resetMaintenanceWindow } = MaintenanceWindowSlice.actions;

export default MaintenanceWindowSlice.reducer;
